import * as R from 'ramda';

export const pickDataFromRange = <Data>(data: Array<Data>, itemsToDisplay: number) => R.take(itemsToDisplay, data);
